import { HttpResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AgenciasService } from 'src/app/_services/agencias.service';
import { AuxiliarService } from 'src/app/_services/auxiliar.service';
import { ModalMsgComponent } from '../modal-msg/modal-msg.component';

@Component({
  selector: 'app-agencias-pendientes',
  templateUrl: './agencias-pendientes.component.html',
  styleUrls: ['./agencias-pendientes.component.css']
})
export class AgenciasPendientesComponent implements OnInit {
  form: FormGroup;
  listAgencias = [];
  cantidad: number;

  constructor(
    private modalService: NgbModal,
    private agenciasService:AgenciasService,
    private auxService:AuxiliarService,
    private formBuilder: FormBuilder,
  ) { }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      search: [''],     
    });
    //cargar listado de agencias pendientes
    this.agencias();
  }

  agencias(){  
    this.listAgencias = [];
    this.agenciasService.agenciasFind('2', this.f.search.value).subscribe(data => {
      if(data instanceof HttpResponse) {
        //verificar token
        if(data.body.msg === 'TOKEN_INVALID' || data.body.msg === 'TOKEN_IS_NOT_FOUND') {
          this.auxService.sessionExpired();
        }
        //acciones
        this.cantidad = data.body.count;
        this.listAgencias = data.body.list;       
      }    
         
    });    
  }

  get f() { return this.form.controls; }

  onSubmit() { //devuelve una lista con el id y el mombre de la agencia
         this.agencias();

  }

  aprobarAll(){
    var list =[];
    for (let i in this.listAgencias) { list.push(this.listAgencias[i].id) }
    
    this.agenciasService.aprobarAll(list).subscribe(data => {
      if(data instanceof HttpResponse) {
        //verificar token
        if(data.body.msg === 'TOKEN_INVALID' || data.body.msg === 'TOKEN_IS_NOT_FOUND') {
          this.auxService.sessionExpired();
        }
        //acciones
        var response = data.body;
        
        if(response.msg === "AGENCIES_ACEPTED" || response.msg === "ERROR_SEND_MAIL") {
          this.agencias();
        } else {
          //Levantar un model
          const modalRef = this.modalService.open(ModalMsgComponent, { 
            centered: true,  
            backdrop:'static',      
          });
          modalRef.componentInstance.titulo = 'Ha ocurrido un error';     
          modalRef.componentInstance.check = 0;
          modalRef.componentInstance.label = 'Volver'; 
        }
      }
    });      
  }


  aprobar(id: string){
    this.agenciasService.aprobarAgencia(id).subscribe(data => {
      if(data instanceof HttpResponse) {
        //verificar token
        if(data.body.msg === 'TOKEN_INVALID' || data.body.msg === 'TOKEN_IS_NOT_FOUND') {
          this.auxService.sessionExpired();
        }
        //acciones
        const modalRef = this.modalService.open(ModalMsgComponent, { 
          centered: true,  
          backdrop:'static',      
        });
        modalRef.componentInstance.label = 'Volver'; 
        var response = data.body;
        if(response.msg === "SEND_MAIL_SUCCESS" || response.msg === "ERROR_SEND_MAIL") {
          modalRef.componentInstance.titulo = 'Agencia aprobada';
          modalRef.componentInstance.check = 1; 
          this.agencias();
        } else {                
          modalRef.componentInstance.check = 0;    
          modalRef.componentInstance.titulo = 'Ha ocurrido un error';                      
        }
      }
    });      
  }

  eliminar(id: string){
    this.agenciasService.rechazarAgencia(id).subscribe(data => {
      if(data instanceof HttpResponse) {
        //verificar token
        if(data.body.msg === 'TOKEN_INVALID' || data.body.msg === 'TOKEN_IS_NOT_FOUND') {
          this.auxService.sessionExpired();
        }
        //acciones
        const modalRef = this.modalService.open(ModalMsgComponent, { 
          centered: true,  
          backdrop:'static',      
        });
        modalRef.componentInstance.label = 'Volver'; 
        var response = data.body;
        if(response.msg === "SEND_MAIL_SUCCESS" || response.msg === "ERROR_SEND_MAIL") {
          modalRef.componentInstance.titulo = 'Agencia eliminada';
          modalRef.componentInstance.check = 1;
          this.agencias();
        } 
        else {          
            modalRef.componentInstance.titulo = 'Ha ocurrido un error';            
            modalRef.componentInstance.check = 0;              
        }
      }
    });      
  }

}
